'use strict';

import angular from 'angular';

/**
 * @ngdoc controller
 * @name observatoireApp.controller:ConventionsMiniereDetailsController
 * @description
 * # Contrôleur pour la page de détails d'une convention minière
 */
angular.module('observatoireApp')
  .controller('ConventionsMiniereDetailsController', [
    '$scope', 
    '$stateParams', 
    '$state', 
    'ConventionsMiniereService',
    'MetaService',
    function($scope, $stateParams, $state, ConventionsMiniereService, MetaService) {
      
      // Initialisation des variables
      $scope.loading = true;
      $scope.conventionId = $stateParams.id;
      $scope.convention = null;
      $scope.error = null;
      
      // Définir les métadonnées de la page
      MetaService.setTitle('Détails de la convention minière');
      MetaService.setDescription('Informations détaillées sur la convention minière.');
      
      /**
       * Chargement des données de la convention
       */
      $scope.chargerConvention = function() {
        $scope.loading = true;
        
        ConventionsMiniereService.getConventionById($scope.conventionId)
          .then(function(convention) {
            $scope.convention = convention;
            
            // Mise à jour du titre avec le nom de la société
            if (convention) {
              MetaService.setTitle('Convention minière - ' + convention.societe);
              MetaService.setDescription('Détails de la convention minière signée avec ' + convention.societe + ' pour le projet ' + convention.projet);
            }
            
            $scope.loading = false;
          })
          .catch(function(error) {
            $scope.error = 'Erreur lors du chargement des détails de la convention: ' + error.message;
            $scope.loading = false;
            console.error('Erreur lors du chargement des détails:', error);
          });
      };
      
      /**
       * Formatage de la date pour l'affichage
       */
      $scope.formaterDate = function(dateStr) {
        if (!dateStr) return 'Non définie';
        
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return new Date(dateStr).toLocaleDateString('fr-FR', options);
      };
      
      /**
       * Retour à la liste des conventions minières
       */
      $scope.retourListe = function() {
        $state.go('main.conventions-minieres');
      };
      
      // Charger les données au démarrage
      $scope.chargerConvention();
    }
  ]);
